import { useEffect, useState } from "react";
import { DropdownOption } from "../dropdown";

const filterDropdownOptionsByRestrictedValues = <T>(options: DropdownOption<T>[], restrictedTValues?: T[], shouldFilter=true) => {
    return shouldFilter && !!restrictedTValues
        ? options.filter(o => restrictedTValues.includes(o.value))
        : options;
}

const useRestrictedDropdownOptions = <T> (originalDropdownOptions: DropdownOption<T>[], restrictedValues?: T[], shouldFilter=true)  => {
    
    const [restrictedDropdownOptions, setRestrictedDropdownOptions] = useState<DropdownOption<T>[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    
    useEffect(() => {
        setIsLoading(true);
        const optionFilteredByRestriction = filterDropdownOptionsByRestrictedValues(originalDropdownOptions, restrictedValues, shouldFilter);
        setRestrictedDropdownOptions(optionFilteredByRestriction);
        setIsLoading(false);
    }, [originalDropdownOptions, restrictedValues, shouldFilter]);

    return {
        restrictedDropdownOptions,
        isLoading
    }
}

export default useRestrictedDropdownOptions;